import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { Text, Flex, ButtonProps } from 'vvs-uikit'

export const StyledButton = styled.button<{ isActive?: boolean }>`
  width: 127px;
  height: 69px;
  border: none;
  background: url('/images/vvsGotchi/vvsgotchi_button_bg_${({ isActive }) => (isActive ? 'active' : 'inactive')}.png');
  background-size: contain;
  background-repeat: no-repeat;
  image-rendering: pixelated;
  cursor: pointer;
  transition: filter 0.25s, transform 0.25s;
  filter: drop-shadow(5px 5px #0000005e);
  transform: translate(0px, 0px);

  &:hover {
    filter: drop-shadow(7px 7px #0000005e);
    transform: translate(-2px, -2px);
  }
  &:active {
    filter: drop-shadow(3px 3px #0000005e);
    transform: translate(2px, 2px);
  }
`
export const StyledInnerText = styled(Flex)`
  flex-direction: column;
  align-items: center;
  transform: translate(-1px, -5px);
}`

interface GamifiedButtonProps extends ButtonProps {
  label: string
  IconComponent: React.FC<{ isActive: boolean }>
  href: string
  isActive: boolean
}

const GamifiedButton: React.FC<GamifiedButtonProps> = ({ label, IconComponent, href, isActive }) => {
  const history = useHistory()

  return (
    <StyledButton isActive={isActive} onClick={() => history.push(href)}>
      <StyledInnerText>
        <Flex width="18px" height="18px" alignItems="center">
          <IconComponent isActive={isActive} />
        </Flex>
        <Text bold color="primary" fontSize="small" mt={-1}>
          {label}
        </Text>
      </StyledInnerText>
    </StyledButton>
  )
}

export default GamifiedButton
